import getBuilderLocalizedValue from "@/i18n/get-builder-localized-value";
import { useLocale } from "@/libs/base/components/locale-provider";
import { cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

type TypographySize = "Display" | "Header" | "Headline" | "Subtitle" | "Body" | "Minimum";
type TypographyVariant = "Normal" | "Light" | "Italic";

interface TypographyProps {
  text: string;
  size?:
    | TypographySize
    /** @deprecated This is a typo */
    | "Minimal";
  variant?: TypographyVariant;
  overrideElement?: string;
  className?: string;
  // From builder.io
  attributes?: any;
}

function getElement(size: TypographySize) {
  switch (size) {
    case "Display":
      return "h1";
    case "Header":
      return "h2";
    case "Headline":
      return "h3";
    case "Subtitle":
    case "Body":
    case "Minimum":
    default:
      return "p";
  }
}

const typography = cva("component-typography", {
  variants: {
    variant: {
      Normal: ["font-normal"],
      Light: ["font-light"],
      Italic: ["font-normal", "italic"],
    },
    size: {
      Display: ["text-display"],
      Header: ["text-header"],
      Headline: ["text-headline"],
      Subtitle: ["text-subtitle"],
      Body: ["text-body"],
      Minimum: ["text-minimum"],
    },
  },
});

export function Typography({
  text: rawText,
  size = "Body",
  variant = "Normal",
  overrideElement,
  className = "",
  attributes,
}: TypographyProps) {
  const locale = useLocale();

  if (size === "Minimal") size = "Minimum";

  const Element = typeof overrideElement !== "undefined" ? overrideElement : getElement(size);
  const text = rawText === undefined ? null : getBuilderLocalizedValue(rawText, locale);

  return (
    <Element
      {...attributes}
      className={twMerge(typography({ variant, size, className: `${className} ${attributes?.className ?? ""}` }))}
      dangerouslySetInnerHTML={{ __html: text }}
    ></Element>
  );
}
